/**
 * Client-side validation for the Join Journey For Teams form
 * @see https://jqueryvalidation.org/
 */
(
  function (window, document, $, _, undefined) {
    const joinFormId = _.get(window, 'joinFormId'), // the form ID
      joinForm = $(`#${joinFormId}`), // the form
      summary = $(`#${joinFormId}_validation_container`); // an element to hold validation messages

    // JQ Validate configuration
    // @see https://jqueryvalidation.org/validate/
    const validationOptions = {
      onfocusout: false,
      onkeyup: false,
      // dynamically generated rules and messages. Generated based on how the Gravity Form is set up
      // @see ThinkPartners\AvmaJourney\Actions\GravityFormsActions->generatePreValidationScript()
      rules: _.get(window, 'joinFormRules', {}),
      messages: _.get(window, 'joinFormMessages', {}),
      ignore: '',
      errorClass: 'invalid',
      // customize the way we place errors within the markup
      errorPlacement: function (err, elem) {
        if (elem.attr('type') === 'checkbox' && elem.parent().hasClass('ginput_container_consent')) {
          err.css('text-transform', 'none');
          elem.siblings('label').first().after(err);
        } else {
          err.appendTo(elem.closest('.gfield'));
        }
      },
      // customize the way we show errors to match what Gravity Forms does
      showErrors: function (errorMap, errorList) {
        summary.html('');

        if (this.numberOfInvalids() > 0) {
          const headingMessage = 'There was a problem with your submission. Please review the fields below.',
            h2 = document.createElement('h2'),
            span = document.createElement('span'),
            ol = document.createElement('ol');

          _.forEach(
            errorList,
            (err) => {
              const message = _.get(err, 'message'),
                elem = _.get(err, 'element'),
                li = document.createElement('li'),
                a = document.createElement('a'),
                fieldContainer = $(elem).closest('.gfield'),
                fieldId = fieldContainer.attr('id'),
                labelText = fieldContainer
                  .find('.gfield_label')
                  .text()
                  .replace('*', '');

              $(a).addClass('gform_validation_error_link')
                .attr('href', fieldId)
                .text(`${labelText}: ${message}`)
                .appendTo(li);
              $(li).appendTo(ol);
            }
          );

          $(h2).addClass('gform_submission_error')
            .text(headingMessage);
          $(span).addClass('gform-icon')
            .addClass('gform-icon--close')
            .prependTo($(h2));

          summary.append(h2)
            .append(ol)
            .removeClass('d-none');
        } else {
          summary.addClass('d-none');
        }

        this.defaultShowErrors();
      }
    };

    /**
     * Custom validations
     */

    // Make sure we get a hex value as a colour
    $.validator.addMethod(
      'hex',
      function (hexValue, element) {
        return this.optional(element) || (/^#(?:[0-9a-fA-F]{3}){1,2}$/).test(hexValue);
      },
      'Please specify a valid colour written in hexadecimal.'
    );

    // Make sure we get a 5-digit zip code, this is syntax only, not Zip validity
    $.validator.addMethod(
      'fiveDigitZip',
      function (value, element) {
        return this.optional(element) || (/^\d{5}$/).test(value);
      },
      'Please enter a 5-digit zip code.'
    );

    // Make sure the value has no spaces, used to ensure single-word names
    $.validator.addMethod(
      'noSpaces',
      function (value, element) {
        return this.optional(element) || !(/\s/).test(value);
      },
      'Spaces are not allowed. Please enter a your first name only.'
    );

    // set up the validation
    $(document).ready(
      function () {
        const validator = joinForm.validate(validationOptions);
        _.set(window, 'validator', validator);
      }
    );
  }
)(window, document, window.jQuery, window.lodash);
